import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative pt-24 pb-16 md:pt-28 md:pb-24 bg-[#1E2652]" }
const _hoisted_2 = { class: "container mx-auto px-4 md:px-6 max-w-6xl" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-12 gap-8" }
const _hoisted_4 = { class: "hidden md:block md:col-span-4 lg:col-span-3" }
const _hoisted_5 = { class: "sticky top-24 bg-white/5 border border-white/10 rounded-xl p-4" }
const _hoisted_6 = { class: "space-y-2" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "md:col-span-8 lg:col-span-9" }
const _hoisted_9 = { class: "bg-white/[0.04] border border-white/10 rounded-2xl p-6 md:p-8" }
const _hoisted_10 = ["id"]
const _hoisted_11 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionsGeneralesPage',
  setup(__props) {


const cguSections = [
  {
    title: "1. Présentation de l'application",
    content: `
      <p>PadelGo est une application mobile éditée par <strong>Rayan Marsile Corp</strong>, SARLAU au capital de 10 000,00 MAD, immatriculée au registre de commerce de Rabat sous le N° RC <strong>184873</strong>, dont le siège social est situé au 45 avenue de France, Appt 8, Agdal, Rabat, Maroc.</p>
      <p>Elle permet aux utilisateurs de :</p>
      <ul class="list-disc list-inside space-y-2">
        <li>Réserver des terrains de padel auprès de <strong>clubs partenaires</strong>.</li>
        <li>Créer ou rejoindre des <strong>parties publiques</strong> ou privées.</li>
        <li>Être mis en relation avec d'autres joueurs.</li>
        <li>Communiquer avec les autres joueurs via la fonctionnalité de <strong>chat</strong> liée aux matchs et réservations.</li>
      </ul>
      <p>L'utilisation de l'application implique l'acceptation pleine et entière des présentes Conditions Générales d'Utilisation (CGU).</p>
      <p>En acceptant les présentes CGU, l'Utilisateur consent expressément à recevoir des <strong>communications commerciales</strong> de la part de PadelGo et de ses partenaires, par email, SMS, notifications push ou tout autre moyen de communication électronique. Ces communications peuvent inclure des offres promotionnelles, des actualités, des événements et des informations relatives aux services proposés par PadelGo et ses partenaires.</p>
    `
  },
  {
    title: "2. Définitions",
    content: `
      <ul class="list-disc list-inside space-y-2">
        <li><strong>Application</strong> : plateforme mobile « PadelGo » éditée par Rayan Marsile Corp.</li>
        <li><strong>Utilisateur</strong> : toute personne utilisant l’Application, qu’elle soit inscrite ou non.</li>
        <li><strong>Club partenaire</strong> : tout club sportif ayant conclu un accord avec PadelGo pour proposer ses terrains à la réservation via l’Application.</li>
        <li><strong>Club non partenaire</strong> : tout club sportif répertorié ou non dans l’Application, n’ayant pas conclu d’accord commercial ou technique avec PadelGo, et pour lequel les réservations sont effectuées directement par l’Utilisateur, en dehors de l’Application.</li>
        <li><strong>Réservation</strong> : acte par lequel un Utilisateur réserve un terrain ou rejoint un match via l’Application.</li>
        <li><strong>Partie publique</strong> : match visible et ouvert à tous les Utilisateurs.</li>
        <li><strong>Partie privée</strong> : match accessible uniquement aux Utilisateurs invités ou disposant du lien d'accès.</li>
        <li><strong>Chat</strong> : fonctionnalité de messagerie permettant la communication entre Utilisateurs liée à un match ou une réservation.</li>
        <li><strong>Service</strong> : ensemble des fonctionnalités offertes par l'Application.</li>
        <li><strong>CGU</strong> : présentes Conditions Générales d'Utilisation.</li>
      </ul>
    `
  },
  {
    title: "3. Nature des services",
    content: `
      <h3 class="text-lg font-medium text-[#B7E000] mb-2">3.1 Clubs partenaires</h3>
      <p>PadelGo agit exclusivement en tant qu’<strong>intermédiaire technique</strong> permettant la mise en relation entre les Utilisateurs et les clubs partenaires.<br>Lorsque l’Utilisateur effectue une réservation via l’Application, il conclut un contrat directement avec le club partenaire concerné.<br>PadelGo n’est pas partie à ce contrat et agit uniquement en qualité de fournisseur technique de la plateforme.</p>
      <p>Les clubs partenaires sont seuls responsables de :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>La disponibilité et la qualité des terrains.</li>
        <li>L’exactitude des informations (horaires, tarifs, photos…).</li>
        <li>L’exécution de la prestation réservée.</li>
      </ul>

      <h3 class="text-lg font-medium text-[#B7E000] mb-2">3.2 Clubs non partenaires – Fonctionnalité "J’ai déjà réservé un terrain"</h3>
      <p>Lorsque l’Utilisateur crée un match public en sélectionnant l’option <strong>"J’ai déjà réservé un terrain"</strong> pour un club non partenaire, il agit en tant qu’<strong>organisateur</strong> du match et déclare avoir effectivement réservé un terrain auprès de ce club par ses propres moyens, en dehors de l’Application.</p>
      <p>L’organisateur est seul responsable :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>de la réservation effective du terrain ;</li>
        <li>de l’exactitude des informations communiquées aux autres joueurs (date, heure, lieu, conditions d’accès) ;</li>
        <li>du bon déroulement du match.</li>
      </ul>
      <p><strong>Affichage des coordonnées de l’organisateur</strong><br>Afin de faciliter l’organisation et la communication, le numéro de téléphone de l’organisateur est affiché aux autres Utilisateurs dans la page du match.<br>En créant un match public via cette fonctionnalité, l’organisateur accepte expressément que son numéro de téléphone soit rendu visible aux autres Utilisateurs de l’Application.</p>
      <p>PadelGo n’est pas partie à cette réservation, ne peut en vérifier l’existence ou la validité, et ne pourra être tenue responsable en cas :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>d’absence de réservation effective,</li>
        <li>d’indisponibilité du terrain,</li>
        <li>d’annulation par le club non partenaire,</li>
        <li>ou de tout incident survenu avant, pendant ou après le match.</li>
      </ul>

      <h3 class="text-lg font-medium text-[#B7E000] mb-2">3.3 Réservations effectuées en dehors de l’Application</h3>
      <p>Toute réservation effectuée par téléphone, email, sur place ou via une autre plateforme est régie exclusivement par les conditions fixées entre le joueur et le club, sans intervention ni responsabilité de PadelGo.</p>
    `
  },
  {
    title: "4. Création et gestion du compte utilisateur",
    content: `
      <ul class="list-disc list-inside space-y-2">
        <li>L’inscription requiert un <strong>nom réel</strong>, une adresse email et un numéro de téléphone valides.</li>
        <li>Un Utilisateur ne peut créer qu’un seul compte personnel.</li>
        <li>L’Utilisateur est responsable de l’exactitude et de la mise à jour de ses informations.</li>
        <li>L’Utilisateur peut ajouter une photo de profil et bénéficie d’un système de niveaux (1 à 10) et de statistiques (matchs joués, victoires/défaites).</li>
        <li>PadelGo se réserve le droit de suspendre ou supprimer tout compte en cas de violation des CGU.</li>
        <li>La suppression d’un compte peut être demandée à tout moment via l’Application ou par email à <strong>support@padelgo.ma</strong>.</li>
      </ul>
    `
  },
  {
    title: "5. Réservations et annulations",
    content: `
      <p><strong>Politique d'annulation</strong> :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li><strong>Par l'Utilisateur</strong> : un match confirmé ou une réservation peut être annulé selon le délai fixé par le club, qui peut varier entre <strong>1 à 4 heures avant</strong> le début du match.</li>
        <li><strong>Par le club</strong> : le club peut annuler à tout moment.</li>
        <li><strong>Annulation automatique</strong> : un match est automatiquement annulé à l'heure prévue s'il n'a pas été confirmé.</li>
      </ul>
      <p><strong>Paiement</strong> :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Les paiements se font <strong>en espèces directement auprès des clubs</strong>.</li>
        <li>Les tarifs sont fixés par les clubs.</li>
      </ul>
      <p><strong>Notifications</strong> : L'Application envoie notamment :</p>
      <ul class="list-disc list-inside space-y-2">
        <li>Confirmation ou annulation d'un match.</li>
        <li>Rappel 2h avant le match.</li>
        <li>Ajout d'un joueur à un match.</li>
        <li>Incitation à renseigner les résultats d'un match.</li>
        <li>Ajout d'un ami.</li>
        <li>Ouverture d'un match par un ami.</li>
      </ul>
    `
  },
  {
    title: "6. Fonctionnalité de chat",
    content: `
      <p>L'Application propose une fonctionnalité de <strong>chat</strong> permettant aux Utilisateurs de communiquer entre eux dans le cadre d'un match ou d'une réservation.</p>
      
      <h3 class="text-lg font-medium text-[#B7E000] mb-2">6.1 Accès au chat</h3>
      <p>Chaque chat est lié à un match ou une réservation spécifique :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li><strong>Pour les matchs publics</strong> : le chat est <strong>public</strong> et accessible à tous les Utilisateurs de l'Application.</li>
        <li><strong>Pour les matchs privés</strong> : le chat est <strong>privé</strong> et accessible uniquement aux Utilisateurs invités au match ou disposant du lien d'accès au match.</li>
      </ul>

      <h3 class="text-lg font-medium text-[#B7E000] mb-2">6.2 Utilisation du chat</h3>
      <p>L'Utilisateur s'engage à :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Utiliser le chat de manière respectueuse et conforme aux présentes CGU.</li>
        <li>Ne pas diffuser de contenus illicites, injurieux, discriminatoires, harcelants ou contraires aux bonnes mœurs.</li>
        <li>Ne pas utiliser le chat à des fins commerciales non autorisées.</li>
        <li>Respecter la vie privée des autres Utilisateurs.</li>
      </ul>

      <h3 class="text-lg font-medium text-[#B7E000] mb-2">6.3 Modération et responsabilité</h3>
      <p>PadelGo se réserve le droit de :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Modérer les contenus échangés dans les chats.</li>
        <li>Supprimer tout message contraire aux présentes CGU.</li>
        <li>Suspendre ou supprimer l'accès au chat pour tout Utilisateur ne respectant pas les règles d'utilisation.</li>
      </ul>
      <p>PadelGo n'est pas responsable des contenus échangés entre Utilisateurs dans les chats. Chaque Utilisateur est seul responsable des messages qu'il publie.</p>
      <p>Les messages échangés dans les chats peuvent être conservés par PadelGo à des fins de modération, de sécurité et de prévention des abus, conformément à la Politique de Confidentialité.</p>
    `
  },
  {
    title: "7. Comportement et sanctions",
    content: `
      <p>L’Utilisateur s’engage à :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Respecter les autres joueurs et les clubs.</li>
        <li>Se présenter aux matchs à l’heure.</li>
        <li>Ne pas adopter de comportement injurieux, discriminatoire ou perturbateur.</li>
      </ul>
      <p>En cas de retards répétés, <em>no-shows</em>, propos inappropriés ou violation des CGU, PadelGo pourra restreindre ou supprimer l'accès au service.</p>
      <p>Les clubs s'autorisent le droit de bloquer l'accès à n'importe quel joueur.</p>
    `
  },
  {
    title: "8. Protection des données personnelles",
    content: `
      <p>Les données personnelles des Utilisateurs sont collectées et traitées par <strong>Rayan Marsile Corp</strong>, société éditrice de l'Application PadelGo, en sa qualité de <strong>responsable du traitement</strong>, conformément à la loi marocaine n°09-08 relative à la protection des données à caractère personnel.</p>
      <p>Les modalités complètes de collecte, traitement, conservation et partage de ces données, ainsi que les droits des Utilisateurs, sont décrites dans la <strong>Politique de Confidentialité</strong> accessible depuis l'Application ou à l'adresse suivante :<br>
      <a class="underline text-[#B7E000]" href="https://padelgo.ma/privacy-policy" target="_blank" rel="noopener">https://padelgo.ma/privacy-policy</a></p>
      <p>L'utilisation de l'Application implique l'acceptation de cette Politique de Confidentialité.</p>
      <p>Conformément à la section 12 des présentes CGU, l'acceptation des CGU vaut consentement à recevoir des communications commerciales de PadelGo et de ses partenaires. L'Utilisateur peut retirer ce consentement à tout moment selon les modalités décrites à la section 12.</p>
    `
  },
  {
    title: "9. Propriété intellectuelle",
    content: `
      <ul class="list-disc list-inside space-y-2">
        <li>Le <strong>code source</strong>, la <strong>base de données</strong> et l’ensemble des contenus de l’Application sont protégés par le droit d’auteur et les lois marocaines.</li>
        <li>Toute reproduction, copie, modification ou distribution, totale ou partielle, sans autorisation écrite, est interdite.</li>
      </ul>
    `
  },
  {
    title: "10. Force majeure",
    content: `
      <p>PadelGo ne pourra être tenue responsable en cas d’inexécution due à un événement de force majeure, notamment :</p>
      <ul class="list-disc list-inside space-y-2">
        <li>Pannes techniques ou coupures internet.</li>
        <li>Défaillance d’un prestataire tiers.</li>
        <li>Catastrophes naturelles.</li>
        <li>Décisions gouvernementales.</li>
      </ul>
    `
  },
  {
    title: "11. Utilisation commerciale interdite",
    content: `
      <p>L'Utilisateur s'interdit de :</p>
      <ul class="list-disc list-inside space-y-2">
        <li>Revendre ou transférer un créneau réservé via PadelGo.</li>
        <li>Utiliser l'Application pour organiser des événements payants non autorisés par les clubs.</li>
      </ul>
    `
  },
  {
    title: "12. Communications commerciales et opt-in marketing",
    content: `
      <p>En acceptant les présentes CGU, l'Utilisateur consent expressément à recevoir des <strong>communications commerciales</strong> de la part de PadelGo et de ses partenaires commerciaux.</p>
      <p>Ces communications peuvent être envoyées par :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Email</li>
        <li>SMS</li>
        <li>Notifications push via l'Application</li>
        <li>Tout autre moyen de communication électronique</li>
      </ul>
      <p>Les communications commerciales peuvent inclure :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Des offres promotionnelles et réductions</li>
        <li>Des actualités et nouveautés concernant l'Application</li>
        <li>Des événements et tournois organisés par PadelGo ou ses partenaires</li>
        <li>Des informations sur les services proposés par PadelGo et ses partenaires</li>
        <li>Des invitations à des événements sportifs ou commerciaux</li>
      </ul>
      <p>L'Utilisateur peut retirer son consentement à tout moment en :</p>
      <ul class="list-disc list-inside space-y-2 mb-4">
        <li>Modifiant ses préférences dans les paramètres de l'Application</li>
        <li>Cliquant sur le lien de désinscription présent dans chaque email commercial</li>
        <li>Envoyant une demande par email à <strong>support@padelgo.ma</strong></li>
      </ul>
      <p>Le retrait du consentement n'affecte pas la validité des traitements effectués avant ce retrait, ni l'utilisation de l'Application pour les fonctionnalités principales (réservations, matchs, etc.).</p>
    `
  },
  {
    title: "13. Offres partenaires",
    content: `
      <p>PadelGo peut afficher des <strong>offres promotionnelles de partenaires</strong> dans l'Application.</p>
    `
  },
  {
    title: "14. Responsabilité",
    content: `
      <p>PadelGo n’est pas responsable :</p>
      <ul class="list-disc list-inside space-y-2">
        <li>Des blessures ou incidents dans les clubs.</li>
        <li>De l’annulation d’un match par un club ou un joueur.</li>
        <li>Du respect des règles sanitaires ou sécuritaires dans les clubs.</li>
        <li>Des litiges entre joueurs.</li>
        <li>Des préjudices indirects tels que perte de chance ou manque à gagner.</li>
      </ul>
    `
  },
  {
    title: "15. Modifications des CGU",
    content: `
      <p>PadelGo peut modifier les CGU à tout moment.</p>
      <p>Les Utilisateurs seront notifiés <strong>par email</strong> avant l’entrée en vigueur.<br>L’utilisation continue du service vaut acceptation des nouvelles CGU.</p>
    `
  },
  {
    title: "16. Litiges et droit applicable",
    content: `
      <p>Les présentes CGU sont régies par le <strong>droit marocain</strong>.</p>
      <p>En cas de litige, les parties s’engagent à rechercher une solution amiable avant toute action judiciaire.<br>À défaut, les tribunaux compétents de <strong>Rabat</strong> seront saisis.</p>
    `
  }
]

function slugifyTitle(title: string): string {
  return title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
}

const toc = cguSections.map((s) => ({ title: s.title, slug: slugifyTitle(s.title) }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-10 md:mb-14 text-center" }, [
        _createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-white tracking-tight" }, " Conditions Générales d'Utilisation (CGU) "),
        _createElementVNode("div", { class: "mt-3 inline-flex items-center gap-2 rounded-full bg-white/10 text-gray-200 px-3 py-1 text-sm" }, [
          _createElementVNode("span", { class: "h-2 w-2 rounded-full bg-[#B7E000]" }),
          _createElementVNode("span", null, "Dernière mise à jour : 5 janvier 2026")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("aside", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-sm font-semibold text-gray-200 mb-3" }, "Sommaire", -1)),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toc), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.slug
                }, [
                  _createElementVNode("a", {
                    href: '#' + item.slug,
                    class: "toc-link block text-sm text-gray-300 hover:text-white"
                  }, _toDisplayString(item.title), 9, _hoisted_7)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("main", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cguSections, (section, index) => {
              return _createElementVNode("section", {
                key: index,
                class: "pt-4 first:pt-0 border-t border-white/10 first:border-t-0"
              }, [
                _createElementVNode("h2", {
                  class: "text-xl md:text-2xl font-semibold text-[#B7E000] mb-3 scroll-mt-28",
                  id: _unref(toc)[index].slug
                }, _toDisplayString(section.title), 9, _hoisted_10),
                _createElementVNode("div", {
                  class: "text-gray-200 leading-relaxed space-y-4",
                  innerHTML: section.content
                }, null, 8, _hoisted_11)
              ])
            }), 64))
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center mt-10" }, [
            _createElementVNode("h3", { class: "text-lg font-semibold text-white mb-3" }, "Questions ?"),
            _createElementVNode("p", { class: "text-gray-300 mb-5" }, "Pour toute question relative à nos conditions d'utilisation, contactez-nous à :"),
            _createElementVNode("a", {
              href: "mailto:support@padelgo.ma",
              class: "inline-flex items-center px-6 py-3 rounded-full bg-[#B7E000] text-[#1E2652] font-medium hover:bg-[#B7E000]/90 transition-colors"
            }, " support@padelgo.ma ")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})